import React from 'react';
import { Section, FadeIn } from './ui';
export function AboutSection() {
  return <Section bg="bg-cream-light" id="sobre-mi" data-id="element-14">
      <FadeIn data-id="element-15">
        <div className="grid md:grid-cols-[auto_1fr] gap-10 md:gap-14 items-center max-w-4xl mx-auto" data-id="element-16">
          {/* Photo */}
          <div className="flex justify-center md:justify-start" data-id="element-17">
            <div className="w-44 h-44 md:w-56 md:h-56 rounded-full overflow-hidden shadow-lg shadow-brown/10 border-4 border-white shrink-0" data-id="element-18">
              <img src="https://cdn.magicpatterns.com/uploads/qhGtHN1gUYvMVikpE3WY9r/IMG_8847.jpg" alt="Estrella, fundadora de Edad Radiante" className="w-full h-full object-cover object-top" data-id="element-19" />
            </div>
          </div>

          {/* Text */}
          <div className="text-center md:text-left" data-id="element-20">
            <span className="inline-flex items-center gap-2 text-coral font-bold tracking-wider uppercase text-sm mb-4" data-id="element-21">
              Sobre mí
            </span>
            <div className="space-y-4 text-lg text-brown leading-relaxed" data-id="element-22">
              <p data-id="element-23">
                <span className="font-bold" data-id="element-24">Soy Estrella, 62 años.</span>
              </p>
              <p data-id="element-25">
                Por años me levantaba agotada y corría al café esperando que ese
                primer sorbo me devolviera la vida.
              </p>
              <p className="italic text-brown-light" data-id="element-26">No funcionaba.</p>
              <p data-id="element-27">
                Hoy empiezo diferente. Un vaso de agua con una pizca de sal del
                Himalaya, unos minutos de sol en la mañana — y mi café lo
                disfruto a media mañana, cuando el cuerpo ya está despierto de
                verdad.
              </p>
              <p data-id="element-28">Esos cambios pequeños lo cambiaron todo.</p>
              <p data-id="element-29">
                Edad Radiante nació de mi propia transformación — para que tú no
                tardes tanto como yo en descubrirla.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}